import styled from 'styled-components';

// colors
import {darkGrey} from '@drivesally/sally-ui/lib/libs/colors';

const SystemMessage = styled.div`
  width: 100%;
  text-align: center;
  font-size: 12px;
  font-style: italic;
  color: ${darkGrey};
  padding: 4px 20px;
`;

export default SystemMessage;
